import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalAutomationRoute: InvariantJiraRoute = {
	name: 'global-automation',
	path: '/secure/Automation([!%]?[\\w]*).jspa',
};
